if(window.location.href.includes('?type=video')){
    $('.uT_video').show()
    $('.product_content').hide()
    $('.video_main .uT_video').hide()
    $('.video_main .uT_video:nth-child(1)').show()
} 
if(window.location.href.includes('?type=using-tips')){
    $('.uT_video').show()
    $('.product_content').hide()
    $('.video_main .uT_video').hide()
    $('.video_main .uT_video:nth-child(2)').show()
}

if(window.innerWidth>750){
    var wFlag = true,box7V=3,box8S=0.6,box8X='-18%',box8Y='2%',box9E='+=200%',box9E2='+=360%',box10V=3.5,box12S='top+=15% top+=6%',box12E='+=250%',
    box13S='top top+=2%',box9S=12000,box9P=5
}else{
    wFlag = false,box7V=1.5,box8S=0.5,box8X='-4%',box8Y='-35%',box9E='+=150%',box9E2='+=140%',box10V=1.4,box12S='top+=28% top+=6%',box12E='+=170%',
    box13S='top top+=7%',box9S=8000,box9P=1.5
    const MpreloadImages = () => {
        for(let i=1;i<31;i++){
            var img = new Image();
            img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_Mbox6_${i}.avif?v=1747902751`;
        }
    };
    MpreloadImages()
    
    $('.box1 video')[0].setAttribute('poster', 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/WEB_BANNER_M_0526.jpg?v=1748223117');
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<31;i++){
        var img = new Image();
        var img2 = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box4_${i}.avif?v=1747822540`;
        img2.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box6_${i}.avif?v=1747894103`;
    }
};
preloadImages()

setTimeout(() => {
    for(let i=1;i<71;i++){
        var img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box8_${i}.avif?v=1747964464`;
    }
    for(let i=1;i<39;i++){
        var img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box9_${i}.avif?v=1747994255`;
    }
}, 2000);

$(()=>{

    // 判断是否为移动设备（通过 userAgent 匹配）
    var isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // 创建 IntersectionObserver（交叉观察器）来监听视频是否进入视口
    var observer = new IntersectionObserver(function (entries, observer) {
        // 遍历所有被观察的视频元素
        $.each(entries, function (i, entry) {
            // 如果当前 entry（视频元素）进入了视口
            if (entry.isIntersecting) {
                // 用 jQuery 获取目标元素
                var $video = $(entry.target);

                // 获取 PC 和 Mobile 的资源地址
                var srcPc = $video.data('src-pc');
                var srcM = $video.data('src-m');

                // 增加容错逻辑：如果没有设置某一端的地址，就使用另一个作为替代
                var src = isMobile
                    ? (srcM || srcPc)  
                    : (srcPc || srcM);

                // 如果存在资源地址，则设置 src，并立即加载
                if (src) {
                    $video.attr('src', src)[0].load();
                }

                // 停止观察当前视频元素，避免重复触发懒加载
                observer.unobserve(entry.target);
            }
        });
    });

    // 找出页面中所有带有 video-lazy 类名的视频并设置为被观察对象
    $('.video-lazy').each(function () {
        observer.observe(this);  // this 是原生 DOM 元素
    });


    // $('.box2_btn').click(function(){
    //     var element = $('.box2 video')[0]
    //     if(element.requestFullscreen){
    //         element.requestFullscreen()
    //     }
    // })

    function showUp(dom){
        gsap.from(dom,{
            y:'2rem',opacity:0,ease:'none',duration:0.5,
            scrollTrigger:{
                trigger:dom,
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
            }
        })
    }

    function linear(dom,value){
        gsap.to(dom,{
            backgroundPosition:value,ease:'none',duration:2,
            scrollTrigger:{
                trigger:dom,
                start:'top center',
                end:'+=0',
                toggleActions:'play none none none',
            }
        })
    }
    
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=6%',
            end:'+=150%',
            pin:true,
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box2 video',{opacity:0.1,duration:0.2})
                .from('.box2_title',{opacity:0,y:'4rem',duration:0.2},'<25%')
                .to('.box2_title',{backgroundPosition:'-20% 0',duration:0.4})
        })
    }else{
        showUp('.box2_title')
        linear('.box2_title','-50% 0')
    }

    showUp('.box3_title')

    //box4 box5
    if(wFlag){    
        ScrollTrigger.create({
            trigger:'.box4_1',
            start:'top top+=6%',
            end:'+=250%',
            pin:true,
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 35);
                if(index>29){
                    index = 29
                }
                //let index = Math.floor(self.progress * 29);
                $('.box4_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box4_${index+1}.avif?v=1747822540`)
            },
            animation:gsap.timeline()
                .to('.box4_title1',{opacity:1,y:'0'})
                .to('.box4_title1',{opacity:0,y:'-6rem'})
                .to('.box4_title2',{opacity:1,y:'0'})
                .to('.box4_title2',{opacity:0,y:'-6rem'})
                .from('.box5',{y:'58rem'},'<50%')
                .from('.box5_title',{opacity:0,y:'2rem'},'<40%')
                .to('.box5_title',{backgroundPosition:'-50% 0'},'<')
        })
    }else{    
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=6%',
            end:'+=150%',
            pin:true,
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 29);
                $('.box4_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box4_${index+1}.avif?v=1747822540`)
            },
            animation:gsap.timeline()
                .to('.box4_title1',{opacity:1,y:'0'})
                .to('.box4_title1',{opacity:0,y:'-6rem'})
                .to('.box4_title2',{opacity:1,y:'0'})
        })

        showUp('.box5_title')
        linear('.box5_title','-50% 0')
    }

    $('.box5_items div').hover(function(){
        $(this).find('video')[0].play()
    },function(){
        var video = $(this).find('video')[0];
        video.currentTime = 0; 
        video.pause();
    })  

    //box6 
    showUp('.box6_title')
    linear('.box6_title','-50% 0') 

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top+=100% top+=6%',
        end:'+=40%',
        scrub:1,
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(!wFlag){
                if(index>2){
                    $('.box6_img').css({opacity:0.3})
                }else{
                    $('.box6_img').css({opacity:1})
                }
            }
        },
        animation:gsap.timeline()
            .from('.box6_items2 div',{opacity:0,y:'2rem',stagger:0.2})
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top top+=6%',
        end:'+=150%',
        pin:true,
        scrub:1,
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 35);
            if(index>29){
                index = 29
            }
            if(wFlag){
                $('.box6_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box6_${index+1}.avif?v=1747894103`)
            }else{
                $('.box6_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_Mbox6_${index+1}.avif?v=1747902751`)
            }

            // $('.box6_items').toggleClass('showup',index>4)
            if(index>4){
                $('.box6_items').css({opacity:1,y:'0'})
                // 执行一次
                if(sq2_flag){
                    startOneo()
                    sq2_flag=false;
                }

                if(index>17){
                    $('.box6_items').css({opacity:0,y:'2rem'})
                }else{
                    $('.box6_items').css({opacity:1,y:'0'})
                }
            }else{
                $('.box6_items').css({opacity:0,y:'2rem'})
            }
            if(index<2){
                // 重置
                sq2_flag=true,sqI1 = 29900,sqI2 = 200
            }
        }
    })

    var sqI1 = 29900,sqI2 = 200,sq2_flag=true,flag_sq2;
    function startOneo(){
        flag_sq2 =  setInterval(num,15)
    }
    function num(){
        sqI1++;
        sqI2++;
        $(`.box6_items .box6_item:nth-child(1) div c`).text(`${sqI1.toLocaleString()}`)
        $(`.box6_items .box6_item:nth-child(2) div c`).text(`${sqI2}X`)
        if(sqI2 > 299){
            clearInterval(flag_sq2);
        }
    }

    //box7
    var box7Swiper = new Swiper('.box7Swiper', {
        slidesPerView: box7V,
        autoplay:!wFlag,
        centeredSlides: true,
        allowTouchMove: !wFlag,
        loop:!wFlag,
        slideToClickedSlide: !wFlag
    })
    box7Swiper.slideTo(1, 0, false)

    showUp('.box7_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box7_item',
            start:'top center',
            end:'+=0%',
            //markers:true,
            animation:gsap.timeline()
                .from('.box7_bg1',{opacity:0,x:'104%'})
                .from('.box7_bg3',{opacity:0,x:'-104%'},'<')
        })
    }

    //box8
    showUp('.box8_title')
    linear('.box8_title div','-50% 0')
    showUp('.box8_items1')

    //第一节动画
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top+=20% top+=6%',
        end:'+=50%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box8_items1 div:nth-child(1)',{opacity:0,x:'-40%',duration:0.1})
            .to('.box8_items1 div:nth-child(2)',{opacity:0,x:'40%',duration:0.1},'<')
            .to('.box8_img',{opacity:1,duration:0.1})
    })

    //第二节序列帧动画
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top+=70% top+=6%',
        end:'+=200%',
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 69);
            // 1-70
            $('.box8_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box8_${index+1}.avif?v=1747964463`)
            if(index>28){
                $('.box8_info1').addClass('showup')
                $('.box8_info2').addClass('showup')
                // 执行一次
                if(xp2_flag){
                    startXp()
                    xp2_flag=false;
                }
                if(index>65){
                    $('.box8_info1').removeClass('showup')
                    $('.box8_info2').removeClass('showup')
                }
            }else{
                $('.box8_info1').removeClass('showup')
                $('.box8_info2').removeClass('showup')
                // 重置
                xp2_flag=true,xpI1 = 79,xpI2 = 10,xpI3 = 0,xpI4 = 60
            }
        }
    })

    //数据浮动
    var xpI1 = 79,xpI2 = 10,xpI3 = 0,xpI4 = 60,xp2_flag=true,flag_xp2;
    function startXp(){
        flag_xp2 =  setInterval(xp2d,30)
    }
    function xp2d(){
        xpI1++;
        xpI2++;
        xpI3++;
        xpI4++;
        $(`.box8_info1 div:nth-child(1) p c`).text(`${xpI1}%`)
        $(`.box8_info1 div:nth-child(2) p c`).text(`${xpI2}%`)
        $(`.box8_info1 div:nth-child(3) p c`).text(`${xpI2}%`)
        $(`.box8_info2 div:nth-child(1) p c`).text(`${xpI3}+`)
        $(`.box8_info2 div:nth-child(2) p c`).text(`$${xpI4}`)
        if(xpI1 > 98){
            clearInterval(flag_xp2);
        }
    }

    //第三节动画
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top+=280% top+=6%',
        end:'+=120%',
        scrub:1,
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>2){
                $('.box8').css({background:'black'})
            }else{
                $('.box8').css({background:'radial-gradient(circle at 50% 168%,#32fc38 0%,#000 66%)'})
            }
        },
        animation:gsap.timeline()
            .to('.box8_flag',{opacity:0})
            .to('.box8_flag2',{scale:box8S,x:box8X,y:box8Y,opacity:0},'<80%')
            .from('.box8_items2',{opacity:0},'<20%')
            .to('.box8_title2',{opacity:1},'<50%')
            .to('.box8_title2',{backgroundPosition:'-20% 0'},'<50%')
    })

    //第四节动画
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top+=400% top+=6%',
        end:'+=40%',
        scrub:1,
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
        },
        animation:gsap.timeline()
            .to('.box8_items2',{x:'-50%'})
    })

    //总固定
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=6%',
        end:'+=460%',
        pin:true,
    })

    //box9
    ScrollTrigger.create({
        trigger:'.box9',
        start:'top bottom-=20%',
        end:box9E,
        scrub:1,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 37);
            $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xp2d_box9_${index+1}.avif?v=1747994255`)
        },
        animation:gsap.timeline()
            .from('.box9_info1',{x:'-150%'})
            .from('.box9_info2',{x:'100%'},'<')
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top+=220% bottom-=20%',
            end:'+=80%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box9_img',{opacity:0})
                .to('.box9_info1',{opacity:0},'<')
                .to('.box9_info2',{opacity:0},'<')
                .from('.box9_content',{opacity:0},'<60%')
        })
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top+=300% bottom-=20%',
            end:'+=80%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>0){
                    $('.box9_items').css({transform:'translate(17%'})
                    $('.box9_line div').css({width:'33%'})
                }
                if(index>40){
                    $('.box9_items').css({transform:'translate(-16%'})
                    $('.box9_line div').css({width:'66%'})
                }
                if(index>80){
                    $('.box9_items').css({transform:'translate(-50%'})
                    $('.box9_line div').css({width:'100%'})
                }
            },
        })
    }else{
        // 未在指定位置生效
        showUp('.box9_title')
    }

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=6%',
        end:box9E2,
        pin:true,
    })

    //box10
    var box10Swiper = new Swiper('.box10Swiper', {
        slidesPerView: box10V,
        centeredSlides: true,
        autoplay:!wFlag,
        allowTouchMove: !wFlag,
        slideToClickedSlide: !wFlag
    })

    showUp('.box10_title')
    linear('.box10_title','-50% 0')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top top+=6%',
            end:'+=150%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>0){
                    box10Swiper.slideTo(0, 500, false)
                }
                if(index>25){
                    box10Swiper.slideTo(1, 500, false)
                }
                if(index>50){
                    box10Swiper.slideTo(2, 500, false)
                }
                if(index>75){
                    box10Swiper.slideTo(3, 500, false)
                }
            },
        })
    }

    //box11
    linear('.box11_title div','-50% 0')

    ScrollTrigger.create({
        trigger:'.box11',
        start:'top top+=30%',
        end:'+=0',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box11_mask',{scale:1})
    })

    $('.box12_items span').each(function() {
        var randomColor = Math.random() < 0.5 ? '#ff8003' : '#ffcc00';
        $(this).css('background', randomColor);
    });

    if(!wFlag){
        $('.box2 video')[0].setAttribute('controls', 'controls');
        $('.box12 video')[0].setAttribute('controls', 'controls');
    }

    //box12
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box12',
            start:'top+=25% top+=6%',
            end:'+=250%',
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .from('.box12_mask',{scale:5,opacity:0,duration:0.25})
                .to('.box12 video',{opacity:0,duration:0.25},'<50%')
                .from('.box12_text',{y:'2rem',opacity:0,duration:0.25})
                .to('.box12_items',{x:'0',duration:0.5})
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box12',
            start:'top top+=6%',
            end:'+=170%',
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .from('.box12_text',{y:'2rem',opacity:0,duration:0.2})
                .to('.box12_items',{x:'-50%',duration:0.5})
        })
    }
 
    ScrollTrigger.create({
        trigger:'.box12',
        start:box12S,
        end:box12E,
        pin:true,
        //markers:true,
    })

    //box13
    ScrollTrigger.create({
        trigger:'.box13',
        start:box13S,
        end:'+=150%',
        scrub:1,
        pin:true,
        //markers:true,
        animation:gsap.timeline()
            .from('.box13_bg',{scale:1.2,y:'-11%'})
            .from('.box13_title',{opacity:0,y:'2rem'})
            .to('.box13_title',{backgroundPosition:'-50% 0'})
            .to('.box13_bg',{opacity:0.1})
            .from('.box13_items',{opacity:0,y:'2rem'})
            .to({},{duration:0.5})//加入停顿
    })

    //box14
    showUp('.box14_title')
    linear('.box14_title','-50% 0')

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/oxva-xlim-pro-2-kit-dna-version'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})